import { BookingFieldEnteredProperties } from '@segment/analytics-next'

import { AnalyticsTrackEvent, TrackBookingFieldEnteredInput } from '@/types'

type CreateBookingFieldEnteredEvent = {
  label: string
  value: string
  section: string
  inputLength: number
  fieldTitle?: string
  fieldType?: string
}

export const createBookingFieldEnteredEvent = ({
  label,
  value,
  section,
  inputLength,
  fieldType,
  fieldTitle,
}: CreateBookingFieldEnteredEvent): Extract<AnalyticsTrackEvent, { object: 'Booking Field'; action: 'Entered' }> => {
  const eventProperties: BookingFieldEnteredProperties = {
    label,
    value,
    input_length: inputLength,
    section,
    field_title: fieldTitle,
    field_type: fieldType,
  }

  return {
    object: 'Booking Field',
    action: 'Entered',
    properties: eventProperties,
  }
}
